"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var Filter = /** @class */ (function () {
    function Filter(_instanceId, _categoryId, _operationType, _actionType, _userId, _modifiedStart, _modifiedEnd, _skipRows, _selectRows, _order, _languageId, _source) {
        this._instanceId = _instanceId;
        this._categoryId = _categoryId;
        this._operationType = _operationType;
        this._actionType = _actionType;
        this._userId = _userId;
        this._modifiedStart = _modifiedStart;
        this._modifiedEnd = _modifiedEnd;
        this._skipRows = _skipRows;
        this._selectRows = _selectRows;
        this._order = _order;
        this._languageId = _languageId;
        this._source = _source;
    }
    Filter.prototype.toHttpParams = function () {
        var search = new http_1.HttpParams();
        if (this._instanceId != null) {
            search = search.append('instanceId', this._instanceId.toString());
        }
        if (this._categoryId != null) {
            search = search.append('categoryId', this._categoryId);
        }
        if (this._operationType != null) {
            search = search.append('operationType', this._operationType);
        }
        if (this._actionType != null) {
            search = search.append('actionTypes', Array.isArray(this._actionType) ? this._actionType.join(',') : this._actionType);
        }
        if (this._userId != null) {
            search = search.append('userId', this._userId.toString());
        }
        if (this._modifiedStart != null) {
            search = search.append('startTime', this._modifiedStart.toString());
        }
        if (this._modifiedEnd != null) {
            search = search.append('endTime', this._modifiedEnd.toString());
        }
        if (this._order != null) {
            search = search.append('order', this._order);
        }
        if (this._skipRows != null) {
            search = search.append('skipRows', this._skipRows.toString());
        }
        if (this._selectRows != null) {
            search = search.append('selectRows', this._selectRows.toString());
        }
        if (this._languageId != null) {
            search = search.append('languageId', this._languageId.toString());
        }
        if (this._source != null) {
            search = search.append('source', this._source.toString());
        }
        return search;
    };
    return Filter;
}());
exports.Filter = Filter;
//# sourceMappingURL=filter.model.js.map